import { render, staticRenderFns } from "./BreakdownTypeList.vue?vue&type=template&id=2dc124e4"
import script from "./BreakdownTypeList.vue?vue&type=script&lang=js"
export * from "./BreakdownTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports